import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import configureStore from './store';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';

import 'core-js/fn/array/from';
import 'core-js/fn/array/fill';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/assign';
import 'core-js/fn/string/trim-end';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/number/parse-float';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';

import './styles/index.scss';

require('dotenv').config();

ReactDOM.render(
  <Provider store={configureStore().store}>
    <PersistGate loading={null} persistor={configureStore().persistor}>
      <App />
    </PersistGate>
  </Provider>, document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js